import { render, staticRenderFns } from "./MasterCompany.vue?vue&type=template&id=393ab02a&scoped=true&lang=pug&"
import script from "./scripts/MasterCompany.js?vue&type=script&lang=js&"
export * from "./scripts/MasterCompany.js?vue&type=script&lang=js&"
import style0 from "./MasterCompany.vue?vue&type=style&index=0&id=393ab02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393ab02a",
  null
  
)

export default component.exports